import { OrdersClient } from '@src/orders/services/OrdersClient';
import { useMutation } from '@tanstack/react-query';

type Props = {
  onSuccess: () => void;
  onError: () => void;
};

export const useForceToReview = ({ onSuccess, onError }: Props) => {
  const { mutate } = useMutation({
    mutationFn: async (data: { orderId: string }) => {
      await OrdersClient.forceToReview({ orderId: data.orderId });
    },
    onSuccess,
    onError,
  });

  return {
    forceToReview: mutate,
  };
};
